import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=ad2243f8&scoped=true&"
import script from "./ShopPage.vue?vue&type=script&lang=ts&"
export * from "./ShopPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2243f8",
  null
  
)

export default component.exports